import api from "api"

const pixels = {
    get: (slug) => {
        return api().get(`/events/detail/${slug}/pixels`)
    },
    getPublic: (slug) => {
        return api().get(`/events/${slug}/pixels/public`)
    },
    create: (slug, payload) => {
        return api().post(`/events/detail/${slug}/pixels`, payload)
    },
    update: (slug, id, payload) => {
        return api().put(`/events/detail/${slug}/pixels/${id}`, payload)
    },
    delete: (slug, id) => {
        return api().delete(`/events/detail/${slug}/pixels/${id}`)
    },
    getTrackingEvents: () => {
        return api().get('/events/pixels/tracking-events')
    }
}

export default pixels;
